import React from "react"
import AddFolioItemButton from "./AddFolioItemButton"
import AlternateIdButton from "./AlternateIdButton"
import DefaultButton from "./DefaultButton"
import AssignHousekeeperButton from "./AssignHousekeeperButton"
import MoveFolioButton from "./MoveFolioButton"
import MakeAdjustmentButton from "./MakeAdjustmentButton"
import NewTaxOrFeeButton from "./NewTaxOrFeeButton"
import NewPaceOrOccupancyButton from "./NewPaceOrOccupancyButton"
import NewOrderDocumentOrSurveyButton from "./NewOrderDocumentOrSurveyButton"
import NewRoomTypeButton from "./NewRoomTypeButton"
import ExcludeButton from "./ExcludeButton"
import ExportCSVButton from "./ExportCSVButton"
import FilterButton from "./FilterButton"
import SelectChartTypeButton from "./SelectChartTypeButton"
import SendEmailButton from "./SendEmailButton"
import SendReceiptButton from "./SendReceiptButton"

var ButtonHelper = {

  /**
  * Renders custom button components
  */
  renderButton: function (button_type, table_action, props) {
    
    var ButtonTypes = {
      AddFolioItem: AddFolioItemButton,
      AlternateId: AlternateIdButton,
      Default: DefaultButton,
      AssignHousekeeper: AssignHousekeeperButton,
      MoveFolio: MoveFolioButton,
      MakeAdjustment: MakeAdjustmentButton,
      NewTaxOrFee: NewTaxOrFeeButton,
      NewPaceOrOccupancy: NewPaceOrOccupancyButton,
      NewOrderDocumentOrSurvey: NewOrderDocumentOrSurveyButton,
      NewRoomType: NewRoomTypeButton,
      Exclude: ExcludeButton,
      ExportCSVButton: ExportCSVButton,
      Filter: FilterButton,
      SelectChartType: SelectChartTypeButton,
      SendEmail: SendEmailButton,
      SendReceipt: SendReceiptButton,
    };

    var ButtonTypeComponent = ButtonTypes[(button_type in ButtonTypes) ? button_type : "Default"];
    return <ButtonTypeComponent key={table_action.label} table_action={table_action} {...props} />;
  },
}

export default ButtonHelper